import seoPages from "./seo-pages.json";

export const SITE_URL =
  (process.env.REACT_APP_PUBLIC_URL || "https://app.tools-products.com").replace(/\/$/, "");

export const SITE_NAME = "Tools for Procreate";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;

export type SeoPage = {
  path: string;
  title: string;
  description: string;
  keywords: string[];
  changefreq: "daily" | "weekly" | "monthly";
  priority: string;
};

export const SEO_PAGES: SeoPage[] = seoPages as SeoPage[];

export const findSeoPage = (pathname: string) =>
  SEO_PAGES.find((page) => page.path === pathname) || SEO_PAGES[0];

export const canonicalPath = (pathname: string) => {
  const cleanPath = pathname
    .replace(/\/(redirect-google|redirect-apple|subscription-activated|trial-activated)$/, "")
    .replace(/\/$/, "");

  return cleanPath || "/";
};
